<template>
  <section 
    class="section--hero">
    <div class="section__container">
      <div class="nav-indicator">
        <nav-indicator :nav-indicator="navIndicator" />
      </div>
      
      <v-row class="section__row" align="center" justify="center">
        <v-col cols="12" class="section__col">
          <div class="text__container">
            
            <!-- Event Category Badge -->
            <div  class="event-category" v-if="normalizedData && normalizedData.category">
              <v-chip 
                size="small" 
                class="event-category-chip"
                :color="normalizedData.category.color"

              >
                {{ normalizedData.category.name }}
              </v-chip>
            </div>
            
            <!-- Event Title -->
            <h1 class="section__title" v-if="normalizedData && normalizedData.name" v-html="normalizedData.name"></h1>
            
            <!-- Event Details Row -->
            <div class="event-details" v-if="normalizedData && (normalizedData.formattedDate || normalizedData.formattedTime || normalizedData.displayLocation)">
              <div class="event-detail" v-if="normalizedData.formattedDate">
                <v-icon class="detail-icon">mdi-calendar</v-icon>
                <span>{{ normalizedData.formattedDate }}</span>
              </div>
              
              <div class="event-detail" v-if="normalizedData.formattedTime">
                <v-icon class="detail-icon">mdi-clock-outline</v-icon>
                <span>{{ normalizedData.formattedTime }}</span>
              </div>
              
              <div class="event-detail" v-if="normalizedData.displayLocation">
                <v-icon
                  size="small"
                  class="detail-icon"
                  :icon="
                    (normalizedData.eventMode === 'Virtual' || normalizedData.trainingMode === 'Virtual')
                      ? 'mdi-monitor'
                      : 'mdi-map-marker-outline'
                  "
                ></v-icon>
                <span>{{ normalizedData.displayLocation }}</span>
              </div>
            </div>
            
          </div>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import NavIndicator from '@/components/partials/NavIndicator.vue';

export default {
  name: 'DetailHeroSection',
  components: {
    NavIndicator,
  },
  props: {
    normalizedData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    navIndicator: {
      type: Array,
      required: false,
      default: () => [],
    },
  }
};
</script>

<style scoped>
.section--hero {
  /* background-color: #f2f2f2; */
  padding-top: 0rem;
  display: flex;
  position: relative;
}

/* Overlay for background images */
.section--hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
  display: none;
}

.section--hero[style*="background-image"]::before {
  display: block;
}

.section--hero[style*="background-image"] .section__container {
  position: relative;
  z-index: 2;
}

.section--hero[style*="background-image"] .section__title,
.section--hero[style*="background-image"] .section__description,
.section--hero[style*="background-image"] .event-category,
.section--hero[style*="background-image"] .event-details {
  color: #ffffff;
}

.nav-indicator {
  padding-left: 3%;
  margin-bottom: 3rem;
}

.section__container {
  margin-top: 0;
  padding-block: 2rem;
  width: 95%;
}

.event-category {
  display: inline-block;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: #777474;

  margin-bottom: 1rem;
}

.section__title {
  letter-spacing: 0%;
  line-height: 110%;
  text-align: center;
  font-size: clamp(24px, 4vw, 44px);
  font-weight: 700;
  margin-bottom: 3rem;
}

.event-details {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-bottom: 1rem;
  align-items: center;
}

.event-detail {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #666;
  font-size: 16px;
}

.detail-icon {
  font-size: 18px !important;
  /* color: #1976d2; */
}

.section__description {
  text-align: left;
  font-size: 16px;
  line-height: 1.6;
  color: #555;
  max-width: 800px;
}

.text__container {
  padding: 2rem 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
}

/* Responsive Design */
@media only screen and (max-width: 630px) {
  .text__container {
    width: 90%;
    margin: auto;
    text-align: left;
    align-items: left;
    display: block;
    justify-content: flex-start;
  }
  .section__title{
    text-align: left;
  }
  .event-details {
    gap: 1rem;
    flex-direction: column;
    
    align-items: flex-start;
  }
  
  .section__title {
    font-size: clamp(20px, 6vw, 32px);
  }
}

@media only screen and (min-width: 960px) {
  .text__container {
    width: 100%;
    /* margin-left: 1.5rem; */
  }
}

@media only screen and (min-width: 1000px) {
  .text__container {
    width: 95%;
    margin-inline: auto;
  }
}

@media only screen and (min-width: 1200px) {
  .text__container {
    width: 90%;
    margin-inline: auto;
  }
}
</style>